
const spdn_t = ["mouseover", "keydown", "touchmove", "touchstart", "wheel"];
var perfEntries = performance.getEntriesByType("navigation");

function optimizeLoad() {
    console.log("User interaction detected, executing deferred scripts...");

    observer.disconnect(); // Disconnect MutationObserver
    executeScripts();

    // Remove event listeners to avoid re-triggering
    spdn_t.forEach(eventType => window.removeEventListener(eventType, optimizeLoad, { passive: true }));
}

// Sequential script execution
function seq(tasks, done, index = 0) {
    tasks[index](() => {
        if (++index === tasks.length) {
            done();
        } else {
            seq(tasks, done, index);
        }
    });
}

// Dispatch lifecycle events to simulate full load
function triggerEvents() {
    var events = ["DOMContentLoaded", "readystatechange", "load", "resize"];
    events.forEach(event => {
        let evt = new Event(event, { bubbles: true });
        window.dispatchEvent(evt);
    });
}

// Convert deferred scripts into active scripts
function executeScripts() {
    let scripts = document.querySelectorAll("script[type='text/spdnscript']");
    let tasks = [];

    scripts.forEach(script => {
        tasks.push(callback => loadScript(script, callback));
    });

    seq(tasks, triggerEvents);
}

// Dynamically create a script tag and append to the DOM
function loadScript(script, callback) {
    let newScript = document.createElement("script");
    newScript.type = "text/javascript";

    if (script.src) {
        newScript.src = script.src;
        newScript.onload = callback;
        newScript.onerror = callback;
    } else {
        try {
            newScript.textContent = script.textContent; // Use textContent instead of innerText
            script.parentNode.replaceChild(newScript, script);
            callback();
        } catch (error) {
            console.error("Error executing script:", error, script.textContent);
        }
    }
}

// Attach lazy loading event listeners
spdn_t.forEach(eventType => window.addEventListener(eventType, optimizeLoad, { passive: true }));

console.log("Lazy script loading initialized...");

